import * as PIXI from "pixi.js";
import Game from "../Game";
import TextureManager from "../managers/TextureManager";
import requestFullscreen from "../utils/fullscreen";
import Checkbox from "../entities/UI/Checkbox";

const Bar = {
  width: 400,
  height: 60,
  radius: 10
}


export default class LoadingLayer extends PIXI.Container {
  private Game = Game.getInstance();
  private button: PIXI.Graphics;
  private buttonTitle: PIXI.Text;
  private handlePress: () => void;
  private elementScale = .5;
  private FsCheckbox: Checkbox;
  private coord: {
    x: number,
    y: number
  };
  constructor(handlePress: () => void) {
    super();
    this.handlePress = handlePress;

    this.addCoord();
    this.isVertical();
    this.addLogo();
    this.drawLoadingBarBg();
    this.addLoadingButton();
    this.addCheckbox();
    this.addToStage();
  }
  addCoord() {
    const dim = this.Game.getDim();
    this.coord = {
      x: dim.WIDTH / 2,
      y: dim.HEIGHT * 5 / 8
    }
  }
  addCheckbox() {
    const dim = this.Game.getDim();
    const x = this.coord.x - 200 * this.elementScale;
    const y = this.coord.y + 80 * this.elementScale;
    this.FsCheckbox = new Checkbox({ x, y }, "Fullscreen", 0xf94f6f, true);
    this.FsCheckbox.scale.set(dim.WIDTH < dim.HEIGHT ? .8 : .6);
    this.addChild(this.FsCheckbox);
  }
  isVertical() {
    const dim = this.Game.getDim();
    if (dim.WIDTH < dim.HEIGHT) {
      this.elementScale = .8;
    }
    return dim.WIDTH < dim.HEIGHT;
  }
  addLogo() {
    const logoTexture = TextureManager.getLogo();
    const logo = new PIXI.Sprite(logoTexture);
    logo.anchor.set(.5);
    logo.scale.set(this.elementScale);
    logo.x = this.coord.x;
    logo.y = this.coord.y - 260 * this.elementScale;
    this.addChild(logo);
  }
  drawLoadingBarBg() {
    const bg = new PIXI.Graphics()
      .roundRect(-Bar.width / 2, -Bar.height / 2, Bar.width, Bar.height, Bar.radius)
      .fill(0xEFEFEF);
    bg.scale.set(this.elementScale);
    Object.assign(bg, this.coord);
    this.addChild(bg);
  }
  addLoadingButton() {
    this.button = new PIXI.Graphics()
      .roundRect(-Bar.width / 2, -Bar.height / 2, 0, Bar.height, Bar.radius)
    Object.assign(this.button, this.coord);
    this.button.scale.set(this.elementScale);

    this.buttonTitle = new PIXI.Text({ text: "Start Game" });
    this.buttonTitle.style.fill = 0x0195b8;
    this.buttonTitle.style.fontSize = 40;
    this.buttonTitle.anchor.set(.5);
    this.buttonTitle.visible = false;
    this.buttonTitle.scale.set(this.elementScale);
    Object.assign(this.buttonTitle, this.coord);

    this.addChild(this.button, this.buttonTitle);
  }
  addButtonInteractivity() {
    const handleButton = () => {
      this.visible = false;
      const isFullscreen = this.FsCheckbox.getIsChecked().isChecked;
      isFullscreen && requestFullscreen();
      setTimeout(() => this.handlePress(), isFullscreen ? 100 : 0);
    }
    this.button.interactive = true;
    this.button.cursor = "pointer";
    this.button.on("mouseup", () => handleButton());
    this.button.on("touchend", () => handleButton())
  }
  drawLoadingButton(percent: number) {
    const barWidth = percent / 100 * Bar.width;
    this.button.clear();
    if (percent == 100) {
      this.buttonTitle.visible = true;
      this.button.roundRect(-Bar.width / 2, -Bar.height / 2, Bar.width, Bar.height, Bar.radius)
        .fill(0x21D4FE);
      this.addButtonInteractivity();
      return
    }
    this.button.roundRect(-Bar.width / 2, -Bar.height / 2, barWidth, Bar.height, Bar.radius)
      .fill(0x21D4FE);
  }
  addToStage() {
    this.Game.stage.addChild(this);
  }
}